<template>
  <div class="multicat container">
    <img id="logo" src="../assets/jpg/image001.jpg" alt="">
    <h1>הנדון: נוהל שידור חשבוניות בהסדר למר"מ</h1>
    <ol>
      <li>תוכנת מיטל יוצרת קובץ העובר למר"מ בתקשורת אינטרנט. הקובץ נוצר ישירות למחיצה "חשבוניות יוצאות"</li>
      <li>לביצוע הפעולה, לחץ על לחצן "קובץ למולטיקט" בנמצא בפינה השמאלית התחתונה במסך הפרמטרים. היעזר בתמונה הבאה:</li>
      <img src="../assets/jpg/image002.jpg" alt="">

      <p>מתקבל המסך הבא:</p>
      <img src="../assets/jpg/image003.jpg" alt="">

      <li>יש לציין חתך תאריכים וללחוץ אישור. אין לשנות רכיבים מתחת לשורת ההגדרות. לאחר אישור הפעולה תבצע התוכנה סריקה של
        חשבוניות מס העונות לקריטריונים של חשבוניות הסדר, (ראה סעיף 5) , תודיע על כמות החשבוניות שנמצאו, ותציג אותם בחלון
        הניתן להדפסה.</li>
      <li>לאחר שיצירת הקובץ הסתיימה, יופיע קובץ עם סיומת "SUP" בתיקיית "חשבוניות יוצאות",לאחר מכן יש לשדר את הקובץ ע"י
        הפעלת תוכנית "תקשורת למ.ר.מ" . התוכנית מאתרת את הקובץ, משדרת אותו, ומיד תמחוק אותו ממחיצת "חשבוניות יוצאות"</li>

      <li>חשבוניות שישודרו הן חשבוניות העונות לתנאים של חשבוניות הסדר. להלן הקריטריונים:
        <br>- שדה קוד מבטח מכיל ערך (שונה משדה ריק)
        <br>- שדה מס תביעה מכיל ערך (שונה משדה ריק)
      </li>

      <li>שדה קוד מבטח:
        <br>- השדה הינו שדה כותרת בכרטיס-עבודה. ומוגדר כשדה טבלאי
        <br>- בזמן שהסמן מגיע אליו נפתחת טבלת קודי מבטחים. יש לשלוף את חברת הביטוח הנכונה מהטבלה.
        <br>- לגבי כרטיסי עבודה שאינם בהסדר אין לגעת בשדה זה, יש להשאירו ריק
        <br>- את טבלת חברות הביטוח ניתן לערוך ולהוסיף רכיבים (חברות עתידיות)
        <br>- ראה דוגמה
      </li>
      <img src="../assets/jpg/image004.jpg" alt="">

      <li>
        שדה קוד מבטח:
        <br>- השדה הינו שדה כותרת בכרטיס-עבודה. ומוגדר כשדה טבלאי
        <br>- בזמן שהסמן מגיע אליו נפתחת טבלת קודי מבטחים. יש לשלוף את חברת הביטוח הנכונה מהטבלה.
        <br>- לגבי כרטיסי עבודה שאינם בהסדר אין לגעת בשדה זה, יש להשאירו ריק
        <br>- את טבלת חברות הביטוח ניתן לערוך ולהוסיף רכיבים (חברות עתידיות)
        <br>- ראה דוגמה
      </li>
      <img src="../assets/jpg/image005.jpg" alt="">

      <li>שדה מס תיק שמאי
        <br>- כעקרון, שדה זה אינו חובה לרוב המבטחים, אך יש מבטחים המחייבים אותו
        <br>- אם מקלידים מס תיק שמאי, יש להיות צמודים לכללי מבנה מס התיק כדלקמן: NNNNNN-NN-NNN
        <br>שדה מע"מ מסחרי
        <br>- יש להקליד בשדה זה בשקלים את סכום המע"מ ששילם הלקוח
        <br>- השדה מיועד רק לתיקונים של רכב-חברה, כאשר המע"מ משולם ע"י החברה.
      </li>
      <li>לנושא חלפים המסופקים:
        <br>- <span class="color-red">חובה לציין מס' קטלוגי, חברת הביטוח דורשת זאת!</span> לגבי חלקים מקוריים ותחליפים,
        לגבי משומשים יש לרשום מק"ט "X" או להשאיר שדה ריק.
        <br>במידה והחלקים הם:
        <br>נורות, קליפסים,נוזלים למיניהם, לוחיות רישוי וכדומה אין חובה לרשום מק"ט אבל חשוב לציין סוג חלק במידה ויש הנחה
        עליו.(במידה ואין יש לסווגו כייצור מקומי).
        <br>- לכל חלק יש לציין סוג חלק. הטור הינו טור טבלאי, ובזמן כניסה אליו נפתחת אוטומטית טבלה כדלקמן:
        <br>
        <img src="../assets/jpg/image006.jpg" alt="">
        <br>- לגבי הטורים ק.ס (קוד ספק) וספק, יש למלא תוכן רק באחד הטורים. ההנחיות כדלקמן: אם לספק החלק יש קוד ספק במר"מ,
        יש לרשום את קוד הספק (מספר בן 1-3 ספרות). במידה ולא יש לרשום את שמו בעמודה "ספק".
        <br>- לגבי הטור ק.ס, ניתן להקליד את קוד ספק החלק ידנית, או להגדיר את הטור כשדה טבלאי, ולהכיל בטבלה את שמות הספקים
        והקודים שלהם לפי טבלאות המר"מ, ראה דוגמה:
      </li>
      <img src="../assets/jpg/image007.jpg" alt="">
      <h3>להלן טבלת קודי מבטחים לפי המר"מ:</h3>
      <table>
        <thead>
        <th>קוד</th>
        <th>שם הספק</th>
        <th>קוד</th>
        <th>שם הספק</th>
        </thead>
        <tr>
          <td>1</td>
          <td>צ'מפיון מוטורס – וולקסווגן/אודי</td>
          <td>21</td>
          <td>חברת המזרח – רובר/אוסטין</td>
        </tr>
        <tr>
          <td>2</td>
          <td>יוניברסל מוטורס – אופל</td>
          <td>23</td>
          <td>דלק מוטורס - מזדה</td>
        </tr>
        <tr>
          <td>3</td>
          <td>ס.מ.ל.ת. – פיאט/אלפא/לנצ'יה</td>
          <td>24</td>
          <td>יוניון מוטורס - טויוטה</td>
        </tr>
        <tr>
          <td>4</td>
          <td>קמור רכב – ב.מ.וו.</td>
          <td>25</td>
          <td>צ'מפיון מוטורס - סקודה</td>
        </tr>
        <tr>
          <td>5</td>
          <td>מאיר חברה למכוניות – וולוו</td>
          <td>26</td>
          <td>יוניברסל מוטורס – ג'נרל מוטורס</td>
        </tr>
        <tr>
          <td>7</td>
          <td>כלמוטור – מיצובישי</td>
          <td>32</td>
          <td>מכשירי תנועה - קרייזלר</td>
        </tr>
        <tr>
          <td>8</td>
          <td>כלמוביל – מרצדס</td>
          <td>38</td>
          <td>יוניברסל מוטורס - סאאב</td>
        </tr>
        <tr>
          <td>9</td>
          <td>יפנאוטו – סובארו</td>
          <td>43</td>
          <td>פאסיפיק מוטורס - ניסאן</td>
        </tr>
        <tr>
          <td>10</td>
          <td>לובינסקי – סיטרואן</td>
          <td>44</td>
          <td>יוניברסל מוטורס - איסוזו</td>
        </tr>
        <tr>
          <td>12</td>
          <td>דלק מוטורס – פורד</td>
          <td>46</td>
          <td>טלקאר - דייהו</td>
        </tr>
        <tr>
          <td>14</td>
          <td>לוביסקי – פיג'ו</td>
          <td>47</td>
          <td>כלמוטור - יונדאי</td>
        </tr>
        <tr>
          <td>15</td>
          <td>קרסו – רנו</td>
          <td>48</td>
          <td>ס.מ.ל.ת. - קיה</td>
        </tr>
        <tr>
          <td>16</td>
          <td>מאיר חברה למכוניות – הונדה</td>
          <td>64</td>
          <td>טלקאר – סאניאנג</td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td>91</td>
          <td>יוניברסל מוטורס – ג'נרל מוטורס-דייהו</td>
        </tr>
        <tr>
          <td>17</td>
          <td>מכשירי תנועה – סוזוקי</td>
          <td>127</td>
          <td>כלמוביל - סקניה</td>
        </tr>
        <tr>
          <td>19</td>
          <td>צ'מפיון מוטורס – סיאט</td>
          <td>128</td>
          <td>תשתית - דאף</td>
        </tr>
        <tr>
          <td>20</td>
          <td>טלקאר - דייהטסו</td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>150</td>
          <td>מוטופרטס</td>
          <td>168</td>
          <td>טרמופרטס</td>
        </tr>
        <tr>
          <td>151</td>
          <td>סופר בודי</td>
          <td>169</td>
          <td>ברוך ובניו</td>
        </tr>
        <tr>
          <td>152</td>
          <td>גל אור</td>
          <td>170</td>
          <td>כולמוטרייד</td>
        </tr>
        <tr>
          <td>153</td>
          <td>פינרוס</td>
          <td>171</td>
          <td>אוטווורקס</td>
        </tr>
        <tr>
          <td>154</td>
          <td>דיסקל</td>
          <td>172</td>
          <td>WARCO</td>
        </tr>
        <tr>
          <td>155</td>
          <td>אוטו גלס</td>
          <td>173</td>
          <td>גרינוולד</td>
        </tr>
        <tr>
          <td>156</td>
          <td>קומט פרוגרס</td>
          <td>174</td>
          <td>ניפון פרטס</td>
        </tr>
        <tr>
          <td>158</td>
          <td>ביתן ספרק</td>
          <td>176</td>
          <td>בשן רדיאטורים</td>
        </tr>
        <tr>
          <td>159</td>
          <td>ש.ש. רדיאטורים</td>
          <td>177</td>
          <td>א.ט.מ שיווק חלפים</td>
        </tr>
        <tr>
          <td>160</td>
          <td>אפל אגזוזים</td>
          <td>178</td>
          <td>אמביל</td>
        </tr>
        <tr>
          <td>161</td>
          <td>גרינברג</td>
          <td>179</td>
          <td>לורדקול</td>
        </tr>
        <tr>
          <td>163</td>
          <td>אמסטרדם</td>
          <td>180</td>
          <td>מורד חלקי חילוף</td>
        </tr>
        <tr>
          <td>164</td>
          <td>ח.ד חלפים</td>
          <td>182</td>
          <td>סמוך – שיפוץ מנועים</td>
        </tr>
        <tr>
          <td>165</td>
          <td>ABC  אוטומוטיב</td>
          <td>194</td>
          <td>המאגר</td>
        </tr>
      </table>
      <li>לנושא הנחות:</li>
      - הנחות יש לרשום <b>בגוף כרטיס העבודה.</b> כל שורה וההנחה שלה
      <br>- אין לתת הנחה כוללת למסמך בעת סגירה לחשבונית
      <li>לפני סגירת כרטיס עבודה בהסדר לחשבונית מס, וודא שהמסמך עומד בתנאים ובקריטריונים של חשבונית הסדר.</li>
      <li>שים לב: כרטיס עבודה לא ישודר למערכת מר"מ. כנ"ל לא תשודרנה חשבוניות זיכוי. רק חשבוניות-מס משודרות. לכן לזיכוי
        בהסדר יש להפיק <b>חשבונית-מס הסדר במינוס</b> ולא חשבונית זיכוי.</li>
      <li>במידה וישנה תקלה מסוימת, הקובץ אינו נוכח בתיקיית "חשבוניות יוצאות" או כל בעיה אחרת בתקשורת למ.ר.מ, יש ליצור קשר
        עם מחלקת התמיכה של מ.ר.מ:</li>
      <p class="color-red"><b>בטלפון- 09-7488666 שלוחות 326,327,328,329,319.</b></p>
      <p class="color-red">
        הערה:

        לקוחות מ.ר.מ בעלי מולטיקט ושמאית יוכלו לבדוק בעצמם אם נכנסה החשבונית לתיק, כמו כן יוכלו להכניס לכרטיס העבודה חלקים
        ישירות ממערכת המולטיפרייס של מ.ר.מ.

        (להסבר איך להתחבר ולקבל את מערכת השמאית יש לפנות למערכת התמיכה של מ.ר.מ)


      </p>
    </ol>

  </div>
</template>

<script>
export default {
  name: 'Multicat',
  data() {

  },
  created() {

  }
  // props: {
  //   msg: String
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.multicat {
  /* text-align: center; */
  flex-grow: 1;
}

.container {
  width: 80%;
}

li {
  margin: 50px 0 0 0;
}

p{
  margin: 50px 0;
}

img {
  margin: 15px 0;
  width: 500px;
  max-width: 100%;
}

.color-red {
  color: red;
}

table,
th,
td {
  font-size: 0.7rem;
  border: 1px solid black;
  border-collapse: collapse;
  text-align: center;
  padding: 10px;
  margin: 10px 0;
}

#logo{
  width: 200px;
}
</style>
